<template>
    <div class="chat-recommended-purchases flex items-center justify-center color-#fff relative" @click.stop="handleRecommendedPurchases">
        <div class="flex items-center justify-center absolute top--30px left--10px w-50px h-50px">
            <img src="@/assets/images/store/gift.webp" alt="recommended-purchases " class="w-100% h-100%" />
        </div>
        <div class="gift-text-box">
            <div class="gift-text">
                {{ t('recommended.gift') }}
            </div>
            <div class="gift-amount absolute top-12px left-3px">
                {{ recommendedPurchases?.giftAmount }}
            </div>
        </div>
        <div class="w-45px h-45px absolute top-6px left-2px">
            <img src="@/assets/images/store/store-3.webp" alt="recommended-purchases" class="w-100% h-100%" />
        </div>
        <div class="flex items-center justify-center absolute top-50% transform -translate-y-1/2 left-40px">
        <div class="text-14px font-800">
                {{ recommendedPurchases?.amount }}
        </div>
        <div class="text-10px ml-10px">
                ${{ recommendedPurchases?.price ? recommendedPurchases.price / 100 : 0 }}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useStorePageStore } from '@/stores/store'
import bridge from '@/utils/bridge'
import { logEventSafe } from '@/plugins/firebase'
import { useI18n } from 'vue-i18n'
import { useRandomArrayStore } from '@/stores/useRandomArrayStore'
const storePageStore = useStorePageStore()
const { t } = useI18n()
const gemItems = computed(() => storePageStore.rechargeItems)
const randomStore = useRandomArrayStore()
const recommendedPurchases = computed(() => {
    if (!gemItems.value || gemItems.value.length === 0) {
        return null
    }
    const firstItem = gemItems.value[0]
    if (!firstItem || !Array.isArray(firstItem.list)) {
        return null
    }
    return firstItem.list.find((item: any) => item.price === 999)
})

const handleRecommendedPurchases = () => {
    if (!recommendedPurchases.value) {
        console.warn('No recommended purchases available')
        return
    }
    logEventSafe('$9.99_popup_click')
    bridge.call(randomStore.randomArray[1], {
        item: recommendedPurchases.value,
        url: '/applePurchase'
    })
}
</script>

<style scoped lang="scss">
.chat-recommended-purchases {
    position: fixed;
    bottom: 200px;
    right: 0;
    z-index: 9;
    width: 120px;
    height: 56px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 10px 0px 0px 10px;
    backdrop-filter: blur(10px);
    animation: slideInFromRight 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;

    .gift-text-box {
        position: absolute;
        top: -16px;
        left: 4px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        color: #CF00FF;
        font-weight: 700;
        font-style: italic;
        text-shadow:
            0 1px 2px rgba(255, 255, 255, 0.5),
            0 -1px 2px rgba(0, 0, 0, 0.2);
            transform: rotate(10deg);
    }

        .gift-text {
        font-size: 11px;
        line-height: 1;
        margin-bottom: 2px;
        letter-spacing: 0.5px;
        transform: rotate(10deg);
        }

        .gift-amount {
        font-size: 10px;
        line-height: 1;
        font-weight: 800;
        transform: rotate(10deg);
        }
    }

// 从右侧滑入动画
@keyframes slideInFromRight {
    0% {
        transform: translateX(100%);
        opacity: 0;
    }
    100% {
        transform: translateX(0);
        opacity: 1;
    }
}
</style>